import { NavLink } from "react-router-dom";
import { Trans } from "react-i18next";
import ProfileManagement from "../components/ProfileManagement";
import { logout } from "../services/authService";
import { useMsal } from "@azure/msal-react";

const EventConfirm = () => {
  const msal = useMsal();

  const Logout = async () => {
    const provider = localStorage.getItem("auth-provider");
    logout();
    if (provider === "azure-sso") {
      await msal.instance.logoutRedirect();
    }
    window.location.reload();
  };
  return (
    <section className="px-[20px] lg:px-16 pb-10 font-Poppins">
      <div className="pt-[60px] flex justify-center md:justify-between items-center">
        <img src="./images/logo-light.png" alt="logo" className="w-[164px] h-auto" />

        <div className="hidden md:block">
          <ProfileManagement theme="light" />
        </div>
      </div>
      <div className="grid items-center lg:grid-cols-2 grid-cols-1">
        <div className="text-[#1E408E] lg:px-10 px-0 py-5">
          <h2 className="font-bold text-center text-4xl leading-10">
            <Trans i18nKey="declaration_registered">
              Thank you,
              <br /> your declaration has been registered
            </Trans>
          </h2>
          <div className="flex justify-center gap-5 lg:gap-5">
            <NavLink to="/event-collect">
              <button className="bg-[#1E408E] text-white mt-10 px-5 lg:px-5 py-2 rounded-full">
                <Trans i18nKey="Declare another event">Declare another event</Trans>
              </button>
            </NavLink>

            <button className="bg-[#1E408E] text-white mt-10 px-5 lg:px-5 py-2 rounded-full" onClick={Logout}>
              <Trans i18nKey="Logout">Logout</Trans>
            </button>
          </div>
        </div>
        <div className="grid justify-center lg:p-20">
          <img src="/images/LoginPage.png" alt="babies" className="max-w-full h-auto" />
        </div>
      </div>
    </section>
  );
};

export default EventConfirm;
